import abTestApiFactory from '../../modules/abTest/abTestApi';

/* Utils */
import {
  generateDefaultAsyncWatcher,
  generateDefaultAsyncSaga,
} from '../core/reduxUtils';

/* Actions */
import {getAbTestActionCreators} from '../actions/abTestActions';

/* Constants */
import {ONE_HOUR_MILISECOND} from '../../common/time/timeConstants';

function abTestSagasFactory({storefrontApiClient}) {
  const abTestApi = abTestApiFactory(storefrontApiClient);

  const getAbTestSaga = generateDefaultAsyncSaga(
    abTestApi.getAbTests,
    getAbTestActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'abtest', cacheStatus: true, expireTime: ONE_HOUR_MILISECOND},
  );

  const watchGetAbTests = generateDefaultAsyncWatcher(
    'GET_AB_TEST',
    getAbTestSaga
  );

  const abTestSagas = [
    watchGetAbTests(),
  ];

  return abTestSagas;
}

export default abTestSagasFactory;







